import LoveSalesAnalytics from '@assets/icons/love-sales-analytics.svg'
import { Icon } from './Icon'

export const LoveSalesAnalyticsIcon = Icon(LoveSalesAnalytics)
